import styled from 'styled-components'

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;

  width: 100%;

  .container-img {
    height: 522px;
    width: 100%;
    display: flex;
    position: relative;
    box-sizing: border-box;
    overflow: hidden;

    img {
      position: absolute;
      top: 0%;
      left: 50%;
      max-width: 200%;
      width: 100%;
      height: 100%;
      width: 100%;
    }
  }
`
